import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-content-body',
  templateUrl: './content-body.component.html',
  styleUrls: ['./content-body.component.sass']
})
export class ContentBodyComponent implements OnInit {

  @Input() isCentralized = false;
  @Input() height = 'auto';

  constructor() { }

  ngOnInit(): void {
  }

  styleObject(): object {
    return {
      'max-height': this.height,
      'min-height': this.height
    };
  }
}
